import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Route, Redirect } from 'react-router-dom';
import LoaderPage from 'components/LoaderPage';
import { makeDebugger } from 'lib';

const debug = makeDebugger('LoggedOutRoute');

class AuthLoader extends Component {
  state = {
    isLoggingIn: false,
    isLoggingOut: false
  }

  componentWillReceiveProps(nextProps) {
    const isLoggingOut = this.props.isAuthed && !nextProps.isAuthed
    const isLoggingIn = !this.props.isAuthed && nextProps.isAuthed
    debug('componentWillReceiveProps()');
    debug('to props:', nextProps);

    this.setState({ isLoggingIn, isLoggingOut });
  }

  render() {
    const { loading, location, isAuthed } = this.props;
    const { isLoggingIn, isLoggingOut } = this.state;
    debug('location: ', location);

    const from = location.state ? location.state.from : { from: { pathname: '/' }};

    // If the isAuthed == true, we know that the auth state is no longer in progress
    if (isAuthed || isLoggingIn) {
      return <Redirect to={'/app'} />
    } else if (isLoggingOut || (!loading && !isAuthed)) {
      return <Redirect to={from} />;
    }

    return <LoaderPage loading={true} />;
  }
}

const LoggedOutRoute = ({ component: Component, isAuthed, loading, ...rest}) => {
  return (
    <Route
      {...rest}
      render={props =>
        // if the auth state isn't still in progress, and no user is authed
        // We can safely display the logged out experience
        !loading && !isAuthed ? (
          <Component {...props} />
        ) : (
          <AuthLoader {...props} loading={loading} isAuthed={isAuthed} />
        )
      }
    />
  );
}

function mapStateToProps(state, ownProps) {
  return {
    isAuthed: state.auth.isAuthed,
    loading: state.auth.loading
  }
}

export default withRouter(connect(mapStateToProps)(LoggedOutRoute))



// WEBPACK FOOTER //
// ./src/containers/LoggedOutRoute.js